import { ServiceMaker, methods, services } from "@/services";

export const createTemplateInapp = payload =>
  ServiceMaker(
    `/communication/templates`,
    methods.POST,
    services.master,
    payload
  );

export const updateTemplateInapp = payload =>
  ServiceMaker(
    `/communication/templates/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

export const fetchInappTemplateAll = (payload) =>
  ServiceMaker(
    `/communication/templates?service=${payload.service}`,
    methods.GET,
    services.master,
    payload
  );